import { styled } from '@zenbusiness/zui/styles';

export const IconBorderStyle = ({ theme }) => ({
  border: `1px solid ${theme.palette.border.main}`,
  backgroundColor: theme.palette.background.grey.light,
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1 1 auto',
  overflowY: 'auto',
  width: '32px',
  height: '32px',
  [theme.breakpoints.up('md')]: {
    width: '40px',
    height: '40px'
  }
});

export const IconBorderStyled = styled('div')(IconBorderStyle);
